module.exports = __webpack_public_path__ + "img/9788932909547.623825bd.jpg";